import base from './_base';

const baseTranslations: typeof base = {
  header: {
    menu: {
      buttons: {
        reviews: {
          label: '',
        },
        resources: {
          label: '',
        },
        tenantResources: {
          label: '',
        },
        tenantUnions: {
          label: '',
        },
        about: {
          label: '',
        },
        faq: {
          label: '',
        },
        contact: {
          label: '',
        },
        submitReview: {
          label: '',
        },
      },
    },
  },
  footer: {
    privacyPolicy: '',
  },
  components: {
    locationDropdowns: {
      country: {
        label: '',
      },
      state: {
        label: '',
      },
      city: {
        label: '',
      },
    },
  },
  landingPage: {
    banner: {
      headline: '',
      buttons: {
        viewReviews: {
          label: '',
        },
        submitReview: {
          label: '',
        },
      },
    },
    callsToAction: {
      headline: '',
      accountability: {
        heading: '',
        body: '',
      },
      transparency: {
        heading: '',
        body: '',
      },
      raiseStandards: {
        heading: '',
        body: '',
      },
    },
  },
  reviewsPage: {
    filters: {
      show: '',
      hide: '',
      filters: '',
      postal: {
        label: '',
      },
      landlord: {
        label: '',
      },
    },
    reviewBox: {
      labels: {
        repair: '',
        stability: '',
        privacy: '',
        respect: '',
      },
      landlordAverage: '',
      errorFetchingHeader: '',
    },
  },
};

export default baseTranslations;
